import {HardwareSensor} from './hardwareSensor';

export class SergasSensor{
  constructor(
    public sergasSensorId: string,
    public description: string,
    public gadgetId: string,
    public elementId: string,
    public sergasDeviceId: string,
    public hardwareSensors: HardwareSensor[]
  ){}
}
